import { render, staticRenderFns } from "./PPersonalizeTable.vue?vue&type=template&id=38020538&scoped=true"
import script from "./PPersonalizeTable.vue?vue&type=script&lang=ts"
export * from "./PPersonalizeTable.vue?vue&type=script&lang=ts"
import style0 from "./PPersonalizeTable.vue?vue&type=style&index=0&id=38020538&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38020538",
  null
  
)

export default component.exports